import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { itemDefinitionsTypes } from './actionTypes';
import {
  getItemDefinitionsListSuccess,
  getItemDefinitionsListFail,
  getMilestoneConfigIVSuccess,
  getMilestoneConfigIVFail,
} from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';


let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchIV = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};

export const fetchItemDef = async (data:any) => {

  const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
  const { sizePerPage, page } = data.pagination;

  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
    GetItemDefinitionList(ItemDefinition: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order : "${order}",
      ${dynamicFilterCF ?? ''}
      ${dynamicFilter ?? ''}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        CountItems
        ItemDefinitionData {
            id
          	ClientId
            PartNumber
            SKUs
            GUIDItem
            Customer
            CustomerGUIDCL
            Inactive
        }
      }
    }
`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    signal
  }).then((res) => res.json());

  return response.data.GetItemDefinitionList;
};

function* fetchItemDefSaga(action:any) {
  try {
    const response: Promise<any> = yield call(fetchItemDef,action.payload);
    yield put(getItemDefinitionsListSuccess(response));
  } catch (error) {
    yield put(getItemDefinitionsListFail(error));
  }
}


function* getMilestoneConfigIV(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, "IV");
    yield put(getMilestoneConfigIVSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigIVFail(error));
  }
}

function* ItemDefSaga() {
  yield takeLatest(itemDefinitionsTypes.GET_ITEM_DEFINITIONS, fetchItemDefSaga);
  yield takeLatest(itemDefinitionsTypes.GET_MILESTONESCONFIG_IV, getMilestoneConfigIV)
}

export default ItemDefSaga;
